export default async ({ store, redirect }) => {
  const { currentUser } = store.state.auth;
  if (currentUser.name) {
    return redirect('/space');
  }
};
